import { all, call, fork, put, takeEvery, take } from "redux-saga/effects";
import { END, eventChannel } from "redux-saga";

import {
  getListVideoLibrarySuccess,
  getListVideoLibraryError,
  getVideoSuccess,
  getVideoError,
  createVideoError,
  createVideoSuccess,
  updateVideoSuccess,
  updateVideoError,
  removeVideoSuccess,
  removeVideoError,
  exportVideoLibraryReportSuccess,
  exportVideoLibraryReportError,
} from "./actions";
import {
  CREATE_VIDEO,
  EXPORT_VIDEO_LIBRARY_REPORT,
  GET_LIST_VIDEO_LIBRARY,
  GET_VIDEO,
  REMOVE_VIDEO,
  UPDATE_VIDEO,
} from "./actionTypes";
import VideoLibraryService from '../../../services/VideoLibraryService';
import { uploadFailure, uploadInitiate, uploadProgress, uploadSuccess } from '../../progress/actions';
import FilesService from '../../../services/FilesService';
import { getFilesArray, getFilesTotalSize } from '../Courses/saga';
import throwCustomError from '../../../helpers/throwCustomError';
import errorCodes from '../../../constants/errorCodes';
import pause from '../../../helpers/pause';
import ToastrService from '../../../services/ToastrService';

const getVideoLibraryListAsync = async (searchParams) => {
  return await VideoLibraryService.getList(searchParams);
};

const getVideoAsync = async (id) => {
  return await VideoLibraryService.getOne(id);
};

const updateVideoAsync = async (data) => {
  return VideoLibraryService.update(data.fileId, data.model);
};

const removeVideoAsync = async (id) => {
  return await VideoLibraryService.remove(id);
};

const exportVideoLibraryReportAsync = async () => {
  return await VideoLibraryService.exportVideoLibraryReport();
};

const videoComposite = (model) => {
  const {
    // aboutTutor,
    // convertkitTagId,
    // equipment,
    // included,
    // lessons,
    // overview,
    // prices,
    // title,
    // urlPart,
    files,
    videoThumbnail,
    // studentsSays,
    // isApplicableToSubscription,
    // isCollaborationCourse,
    tags,
    title,
    fileId,
  } = model;

  return {
    files,
    videoThumbnail,
    tags,
    videoData: {
      tags,
      title,
      fileId,
    }
    // videoTitle,
    // courseData: {
    //   aboutTutor,
    //   convertkitTagId,
    //   equipment,
    //   included,
    //   lessons,
    //   overview,
    //   prices,
    //   title,
    //   urlPart,
    //   studentsSays,
    //   isApplicableToSubscription,
    //   isCollaborationCourse
    // },
  };
};

/**
 * Video files channel for files uploading watching
 * @param data<Object>
 * @param mode<"create"|"update"> - mode of files progress channel (create by default)
 */
const videoFilesChannel = (data, mode = "create") => {
  return eventChannel((emit) => {
    const { model } = data;
    //We need to have file title inside file object
    const { files, videoThumbnail, tags, videoData } = videoComposite(model);
    // const id = mode === "create" ? data.categoryId : data.courseId;
    // const actionFunc =
    //   mode === "create"
    //     ? CourseService.create(id, courseData)
    //     : CourseService.update(id, courseData);
      const onProgress = ({ loaded }, file, chunkIndex) => {
        emit({ file, loaded, chunkIndex });
      };

      console.log('getFilesArray', getFilesArray(files, videoThumbnail) || []);
      console.log('getFilesTotalSize', getFilesTotalSize(files, videoThumbnail) || 0);
     
      // pause(1000)
      
      //IIFE 
      (async () => {
          // if (!!tags && !!tags.length && (!files || !files.length)) {
          //   await CourseService.updateVideoTags(
          //     course.id,
          //     tags
          //   ).catch((error) => {
          //     console.log("error", error);
          //   });
          // }
          // pause(1000).then(() => {
          //   emit({
          //     files: getFilesArray(files, videoThumbnail) || [],
          //     filesTotalSize: getFilesTotalSize(files, videoThumbnail) || 0,
          //   });
          // });

          await pause(100);

          // if (mode === "update" && !!files && !!videoThumbnail) {
          //   return updateVideoAsync(videoData);
          // } else {

          // }


          emit({
            files: getFilesArray(files, videoThumbnail) || [],
            filesTotalSize: getFilesTotalSize(files, videoThumbnail) || 0,
          });

          const filesResponse =
            !!files &&
            !!files.length &&
            (await FilesService.uploadVideoFile({ files }, onProgress).catch(
              (error) => {
                throwCustomError(error);
              }
            ));
          const videoThumbnaiResponse = !!videoThumbnail &&
          !!videoThumbnail.length && (await FilesService.uploadImageFile(
            { files: videoThumbnail },
            onProgress
          ).catch((error) => {
            throwCustomError(error);
          }));
          return { filesResponse, videoThumbnaiResponse };
        })()
        .then(({ filesResponse, videoThumbnaiResponse }) => {
          
          if (!!filesResponse && !!videoThumbnaiResponse) {
            return VideoLibraryService.upsertVideoThumbnail({
              fileId: filesResponse[0].file.id,
              videoThumbnailId: videoThumbnaiResponse[0].file.id,
              tags: tags || []
            }).catch((error) => {
              throwCustomError(error);
            });
          } else if (!!videoThumbnaiResponse && mode === "update") {
            let { fileId, ...rest } = videoData;
            rest.videoThumbnailId = videoThumbnaiResponse[0].file.id;
            return VideoLibraryService.update(videoData.fileId, rest).catch(
              (error) => {
                throwCustomError(error);
              }
            );
          } else if (mode === 'update' && !videoThumbnaiResponse) {
            let { fileId, ...rest } = videoData;
            return VideoLibraryService.update(videoData.fileId, rest).catch(
              (error) => {
                throwCustomError(error);
              }
            );
          }
          // else if (!!videoThumbnaiResponse) {
          //   return CourseService.changeVideoThumbnail(
          //     course.id,
          //     videoThumbnaiResponse[0].file.id
          //   ).catch((error) => {
          //     throwCustomError(error);
          //   });
          // }
        })
        .then((result) => {
          emit({ success: result });
          emit(END);
        })
        .catch((err) => {
          emit({ err });
          emit(END);
        });
      return () => {};
  });
};

function* getVideoLibraryList({ payload }) {
  try {
    const response = yield call(getVideoLibraryListAsync, payload);
    yield put(getListVideoLibrarySuccess(response));
  } catch (error) {
    yield put(getListVideoLibraryError(error));
  }
}

function* getVideo({ payload: { fileId } }) {
  try {
    const response = yield call(getVideoAsync, fileId);
    yield put(getVideoSuccess(response));
  } catch (error) {
    yield put(getVideoError(error));
  }
}

function* createVideoProgressListener(chan, history) {
  while (true) {
    const { files, filesTotalSize, file, loaded, chunkIndex, err, success } =
      yield take(chan);
    if (!!files && !!filesTotalSize) {
      yield put(uploadInitiate({ files, filesTotalSize }));
    }
    if (err) {
      if (err.code === errorCodes.BAD_REQUEST_ERROR) {
        yield put(createVideoError(err));
      } else {
        yield put(uploadFailure(err));
        yield put(createVideoError(err));
        history.push(`/video-library`);
      }
      return;
    }
    if (success) {
      yield put(uploadSuccess(success));
      yield put(createVideoSuccess(success));
      history.push(`/video-library`);
      return;
    }
    if (!!file && !!loaded) {
      yield put(uploadProgress({ file, loaded, chunkIndex }));
    }
  }
}

function* updateVideoProgressListener(chan, history) {
  while (true) {
    const { files, filesTotalSize, file, loaded, chunkIndex, err, success } =
      yield take(chan);
    if (!!files && !!filesTotalSize) {
      yield put(uploadInitiate({ files, filesTotalSize }));
    }
    if (err) {
      if (err.code === errorCodes.BAD_REQUEST_ERROR) {
        yield put(updateVideoError(err));
      } else {
        yield put(uploadFailure(err));
        yield put(updateVideoError(err));
        history.push(`/video-library`);
      }
      return;
    }
    if (success) {
      yield put(uploadSuccess(success));
      yield put(updateVideoSuccess(success));
      history.push(`/video-library`);
      return;
    }
    if (!!file && !!loaded) {
      yield put(uploadProgress({ file, loaded, chunkIndex }));
    }
  }
}

function* createVideo({ payload: { data, history } }) {
  try {
    yield fork(
      createVideoProgressListener,
      videoFilesChannel(data),
      history
    );
  } catch (error) {
    yield put(createVideoError(error));
  }
}

// function* updateVideo({ payload: { data, history } }) {
//   try {
//     const response = yield call(updateVideoAsync, data);
//     yield put(updateVideoSuccess(response));
//     history.push(`/video-library`);
//   } catch (error) {
//     yield put(updateVideoError(error));
//   }
// }

function* updateVideo({ payload: { data, history } }) {
  try {
    yield fork(
      updateVideoProgressListener,
      videoFilesChannel(data, "update"),
      history
    );
  } catch (error) {
    yield put(updateVideoError(error));
  }
}

function* removeVideo({ payload: { data, history } }) {
  try {
    const response = yield call(removeVideoAsync, data);
    yield put(removeVideoSuccess(response));
    history.push(`/video-library`);
    ToastrService.success("Video removed successfully");
  } catch (error) {
    ToastrService.error(error.message);
    yield put(removeVideoError(error));
  }
}

function* exportVideoLibraryReport() {
  try {
    const response = yield call(exportVideoLibraryReportAsync);
    yield put(exportVideoLibraryReportSuccess(response));
    // history.push(`/video-library`);
    ToastrService.success("Video library report requested successfully");
  } catch (error) {
    ToastrService.error(error.message);
    yield put(exportVideoLibraryReportError(error));
  }
}

export function* watchGetVideoLibraryList() {
  yield takeEvery(GET_LIST_VIDEO_LIBRARY, getVideoLibraryList);
}

export function* watchGetVideo() {
  yield takeEvery(GET_VIDEO, getVideo);
}

export function* watchCreateVideo() {
  yield takeEvery(CREATE_VIDEO, createVideo);
}

export function* watchUpdateVideo() {
  yield takeEvery(UPDATE_VIDEO, updateVideo);
}

export function* watchRemoveVideo() {
  yield takeEvery(REMOVE_VIDEO, removeVideo);
}

export function* watchExportVideoLibraryReport() {
  yield takeEvery(EXPORT_VIDEO_LIBRARY_REPORT, exportVideoLibraryReport);
}

function* videoLibrarySaga() {
  yield all([
    fork(watchGetVideoLibraryList),
    fork(watchGetVideo),
    fork(watchCreateVideo),
    fork(watchUpdateVideo),
    fork(watchRemoveVideo),
    fork(watchExportVideoLibraryReport),
  ]);
}

export default videoLibrarySaga;
